module.exports = __webpack_public_path__ + "static/img/Brett.Clothier.c310450.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brett.Clothier.jpg
// module id = xu1M
// module chunks = 0